import { Component, Input } from '@angular/core';
import { IconName, PalleteColor } from 'nanaykuna-ui-kit/loader';

@Component({
  selector: 'unicon-menu-tooltip',
  templateUrl: './menu-tooltip.component.html',
})
export class MenuTooltipComponent {
  @Input() icon: IconName = 'info-outline';
  @Input() fill: PalleteColor = 'neutrals-700';
}
